import styled from '@emotion/styled';

export const FileUploadListItemIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
`;
